module.exports = __webpack_public_path__ + "img/ExitusC_personas1.85b2e10d.png";